import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MemberSubmissionAccount } from '../../../../models/transactions/member-submission-account';

@Component({
  selector: 'app-defined-contribution-accounts-accordion',
  templateUrl: './defined-contribution-accounts-accordion.component.html',
  styleUrls: ['./defined-contribution-accounts-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DefinedContributionAccountsAccordionComponent {
  private router = inject(Router);

  @Input() accounts: MemberSubmissionAccount[] = [];

  public isCollapsed = true;

  public headerClicked(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  public goToAccount(accountId: number): void {
    this.router.navigate(['/accounts', accountId]);
  }
}
